// extracted by mini-css-extract-plugin
export default {"template1":"styles_template1__L4PXB","template1__heading":"styles_template1__heading__lx8PN","template1__frame":"styles_template1__frame__0lhGg"};